export const REMOVING_GROUP_MEMBERS = "removeGroupMembers";
export const REMOVING_SAMPLE_GROUP_SAMPLES = "removingSampleGroupSamples";
